import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { debounce: { type: Number, default: 0 } }

  submit() {
    if (this.debounceValue <= 0) {
      this.element.requestSubmit()
      return
    }

    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.debounceValue)
  }
}
